import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import KeyValueItem from "entities/KeyValueItem";
import i18n from "i18n";
import { apiCallBegan } from "store/api";
import { AppDispatch, AppState } from "store/configureStore";
import SliceCollectionBase from "store/types/SliceCollectionBase";
import { authHeader } from "store/users/auth";

interface KeyValueResponse {
    Id: number;
    Name: string;
}

interface State extends SliceCollectionBase<KeyValueItem> { }

const initialState: State = {
  list: [],
  loading: false,
  lastFetch: null,
  error: null
}


const slice = createSlice({
    name: "positionTypes",
    initialState,
    reducers: {
    positionTypesRequested: (positionTypes) => {
      positionTypes.loading = true;
      positionTypes.error = null;
    },
    positionTypesReceived: (positionTypes, action: PayloadAction<KeyValueResponse[]>) => {
      positionTypes.list = schema(action.payload);
      positionTypes.loading = false;
      positionTypes.lastFetch = Date.now();
    },
    positionTypesRequestFailed: (positionTypes, action) => {
      positionTypes.loading = false;
      positionTypes.error = action.payload;
    }
   }
});

const {
  positionTypesRequested,
  positionTypesReceived,
  positionTypesRequestFailed
} = slice.actions;

export const getCompanyPositionTypes = () => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (getState().entities.positionTypes.loading) {
    return;
  }

  const companyId = getState().users.auth.data?.CompanyId ?? 0;

  const url = `api/workdetails/positionTypes/${companyId}`;

  var result =  dispatch(
      apiCallBegan({
          url,
          method: "GET",
          headers: { ...authHeader(), "Accept-Language": i18n.language },
          onStart: positionTypesRequested.type,
          onSuccess: positionTypesReceived.type,
          onError: positionTypesRequestFailed.type
      })
  );
  return result
}

const schema = (payload: KeyValueResponse[]): KeyValueItem[] => {
  if (!payload || payload.length === 0) {
    return [];
  }

  return payload.map((resp: KeyValueResponse): KeyValueItem => (
    {
      id: resp.Id,
      value: resp.Name
    }
  ))
};

export default slice.reducer;
